"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var FieldPrompt = function FieldPrompt(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-xs my-1 h-4', {
      'text-red': variant === 'error',
      italic: variant === 'info'
    })
  }, children);
};

var _default = FieldPrompt;
exports["default"] = _default;
//# sourceMappingURL=FieldPrompt.js.map